(function () {
  if (window.__cartRemoveItemBound === true) return;
  window.__cartRemoveItemBound = true;

  document.addEventListener('click', function (event) {
    var link = event.target != null && event.target.closest != null
      ? event.target.closest('[data-cart-remove]')
      : null;
    if (link == null || link.classList.contains('is-removing')) return;

    var key = link.getAttribute('data-line-key');
    if (key == null || key === '') return;

    event.preventDefault();
    link.classList.add('is-removing');

    // QA 26.07.26: se reserva un numero de secuencia antes de mandar la
    // peticion, igual que en js-cart-quantity-stepper.js -- si una sync
    // mas vieja (del stepper o del cargar-pagina) responde DESPUES de
    // esto, __cartSyncApplyIfCurrent la descarta en vez de pisar el
    // carrito ya actualizado. Ver comentario largo en
    // js-cart-totals-sync.js.
    var syncId = window.__cartSyncBumpSeq();

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (cart != null && cart.item_count === 0) {
          window.location.reload();
          return;
        }

        var row = link.closest('.cart-item');
        if (row != null) row.remove();

        /* CRO 18.07.26 (QA): antes esto solo actualizaba el subtotal a mano
           (con total_price, correcto) pero no tocaba el Total/Ahorras por
           producto de las lineas restantes -- al quitar un renglon, el
           reparto proporcional del descuento entre los que quedan cambia,
           asi que hace falta recalcular todos, no solo el eliminado. Se usa
           el mismo corrector compartido (window.__syncCartTotals) en vez de
           duplicar la logica aqui. */
        if (cart != null) {
          window.__cartSyncApplyIfCurrent(syncId, cart);
        }

        var $bubbleCount = document.querySelector('.cart-count-bubble span');
        if ($bubbleCount != null && cart != null) $bubbleCount.textContent = cart.item_count;
      })
      .catch(function () {
        link.classList.remove('is-removing');
      });
  });
})();
